export default __webpack_public_path__ + "static/media/tete97.52d0d909.png";